// extracted by mini-css-extract-plugin
export default {"authors":"Authors_authors__Z36jJ"};